module.exports = __webpack_public_path__ + "img/report2-4.eb9a6222.jpg";